<template>
  <vue-chosen
    v-model="value"
    :name="'filter_' + fieldKey + '[]'"
    :options="options"
    :multiple="true"
    class="form-control"
    placeholder="..."
  ></vue-chosen>
</template>

<script>
export default {

  props: {
    operator: {type: String, required: true},
    fieldKey: {type: String, required: true},
    fieldValue: {type: [String, Array], default: ''},
    options: {type: Array, default: function () { return [] }},
  },

  /**
   * Variables (models).
   */
  data () {
    return {
      value: this.fieldValue ?? '',
    }
  }

}
</script>

